
export function getShowPath(type, src) {
  if (src) {
    if (src.indexOf('https://') === 0) {
      return src
    }
    if (type === 'img') {
      return `https://img.libraryplus.bjadks.com/${src}`
    } else {
      return `https://v.libraryplus.bjadks.com/${src}`
    }
  }
  return ''
}
